import { useTheme } from 'styled-components'
import { BlockIcon } from '@velasca/icons/block-icon'
import { CheckIcon } from '@velasca/icons/check'
import { CloseIcon } from '@velasca/icons/close'
import { ContainedInfoIcon } from '@velasca/icons/contained-info-icon'
import { WarningIcon } from '@velasca/icons/warning-icon'
import { IconButton } from '../IconButton/IconButton'
import { SansText } from '../SansText/SansText'
import {
  ErrorToast,
  InfoToast,
  MessageContainer,
  SuccessToast,
  ToastContainer,
  WarningToast,
} from './Toast.styles'
import type { ToastProps } from './Toast.types'

export const Toast = ({
  variant,
  message,
  verticalPositionCenter = true,
  onCancel,
}: ToastProps): JSX.Element => {
  const theme = useTheme()

  return (
    <ToastContainer verticalPositionCenter={verticalPositionCenter}>
      {variant === 'success' && (
        <SuccessToast>
          <CheckIcon width="22" height="22" color={theme.colors.background} />
          <MessageContainer>
            <SansText size="base" color="white">
              {message}
            </SansText>
          </MessageContainer>
          <IconButton
            iconSize="22px"
            clickAreaSize="24px"
            color="inherit"
            onClick={onCancel}
          >
            <CloseIcon width="22" height="22" color={theme.colors.background} />
          </IconButton>
        </SuccessToast>
      )}
      {variant === 'info' && (
        <InfoToast>
          <ContainedInfoIcon width="24" height="24" />
          <MessageContainer>
            <SansText size="base" color="light">
              {message}
            </SansText>
          </MessageContainer>
          <IconButton
            iconSize="22px"
            clickAreaSize="24px"
            color="inherit"
            onClick={onCancel}
          >
            <CloseIcon
              width="22"
              height="22"
              color={theme.colors.primaryLight}
            />
          </IconButton>
        </InfoToast>
      )}
      {variant === 'warning' && (
        <WarningToast>
          <WarningIcon width="24" height="24" color={theme.colors.danger} />
          <MessageContainer>
            <SansText size="base" color="error">
              {message}
            </SansText>
          </MessageContainer>
          <IconButton
            iconSize="22px"
            clickAreaSize="24px"
            color="inherit"
            onClick={onCancel}
          >
            <CloseIcon width="22" height="22" color={theme.colors.danger} />
          </IconButton>
        </WarningToast>
      )}
      {variant === 'error' && (
        <ErrorToast>
          <BlockIcon width="24" height="24" color={theme.colors.danger} />
          <MessageContainer>
            <SansText size="base" color="white">
              {message}
            </SansText>
          </MessageContainer>
          <IconButton
            iconSize="22px"
            clickAreaSize="24px"
            color="inherit"
            onClick={onCancel}
          >
            <CloseIcon width="22" height="22" color={theme.colors.background} />
          </IconButton>
        </ErrorToast>
      )}
    </ToastContainer>
  )
}
